import HeadhuntServicePage from 'src/@legacy/@optimal-page/pages/employer/headhunt-service/headhunt-service'
import dynamic from 'next/dynamic'
import React from 'react'
const FooterAfterLogin = dynamic(() => import('src/@legacy/layout/FooterAfterLogin'))
import LazyLoad from 'react-lazyload'
import Head from 'next/head'
const HeadHuntPageWithFooter = (props) => (
  <>
    <HeadhuntServicePage {...props} />
    <LazyLoad height={200}>
      <FooterAfterLogin />
    </LazyLoad>
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: `!function(){if(!window.EncTracking||!window.EncTracking.started){window.EncTracking=Object.assign({}, window.EncTracking, {queue:window.EncTracking&&window.EncTracking.queue?window.EncTracking.queue:[],track:function(t){this.queue.push({type:"track",props:t})},identify:function(t){this.queue.push({type:"identify",props:t})},started:!0});var t=window.EncTracking;t.writeKey="waL8BTHXFqJz1Prr1eFzc84QL",t.hasOptedIn=true,t.shouldGetConsent=true,t.hasOptedIn&&(t.shouldGetConsent=!1),t.optIn=function(){t.hasOptedIn=!0,t&&t.init&&t.init()},t.optOut=function(){t.hasOptedIn=!1,t&&t.setOptOut&&t.setOptOut(!0)};var n=function(t){var n=document.createElement("script");n.type="text/javascript",n.async=void 0===t||t,n.src="https://resources-app.encharge.io/encharge-tracking.min.js";var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};"complete"===document.readyState?n():window.attachEvent?window.attachEvent("onload",n):window.addEventListener("load",n,!1)}}();`
        }}
      />
      <script src="https://cdn.pagesense.io/js/815745708/181753d3c7eb47fd8b74f92ca478e1c5.js"></script>
    </Head>
  </>
)
export default HeadHuntPageWithFooter
export const config = { unstable_JsPreload: false }
